export enum MatchEventType {
  Card = 'card',
  Chance = 'chance',
  Goal = 'goal',
  PenaltyFail = 'penaltyfail',
  Substitute = 'substitute',
  Text = 'text',
  Timeout = 'timeout',
  Whistle = 'whistle',
  TimePenalty = 'timepenalty',
  TeamFoul = 'teamfoul',
  LineupEntered = 'lineupentered',
  LineupsCompleted = 'lineupscompleted',
}
